import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import cnc from "@clickncode/ui-vue/src/index.js"

Vue.config.productionTip = false

let endpoint = window.location.hostname.includes("localhost")
  ? "http://localhost:3000/graphql"
  : window.location.protocol +
    "//" +
    window.location.hostname +
    (window.location.port ? ":" + window.location.port : "") +
    "/graphql"
Vue.use(cnc, {
  endpointUrl: localStorage.getItem("endpointUrl") || endpoint,
  authToken: sessionStorage.getItem("authToken")
})

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
